import { useTranslation } from 'react-i18next';

/** Asosiy tugma o'chiq bo'lsa — nima yetishmayotganini aniq ko'rsatadi ("Davom etish uchun:"). */
export function MissingList({
  items,
  className = 'mt-4',
}: {
  items: string[];
  className?: string;
}) {
  const { t } = useTranslation();
  if (items.length === 0) return null;
  return (
    <div className={`card border-dashed px-5 py-4 text-sm ${className}`}>
      <p className="mb-2 font-semibold">{t('order.missingTitle')}</p>
      <ul className="space-y-1.5 text-muted">
        {items.map((m) => (
          <li key={m} className="flex gap-2">
            <span className="text-amber">○</span>
            {m}
          </li>
        ))}
      </ul>
    </div>
  );
}
